import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef} from "react";
import {useParams} from "react-router-dom";
import NavBreadcrumb from "components/NavBreadcrum";

import axiApi from "ApiCaller";
import MapAssetContainer from "site-apps/assets/MapAssetContainer";
import navs from "../navs";
import DateUtils from "core/utils/DateUtils";
import AssetsList from "./AssetsListTabs";
import IslandModel from "site-apps/distribution/island/IslandModel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AlertsTypesCharts} from "site-apps/alerts/AlertsTypesCharts";
import ContainerIconValues from "../components/waste/ContainerIconValues";
import DropdownDateRange from "components/datetime/DropdownDateRange";
import ConditionalRender from "components/ConditionalRender";
import ImageModal from "components/ImageModal";
import ModalIslandImages from "site-apps/distribution/island/ModalIslandImages";
import CustomTranslation from "core/customTranslation";
import LoaderSpinner from "context/LoaderSpinner";
import {MomentUtils} from "core/utils/MomentUtils";

const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";

const translations = {
    en: {
        images: "Images",
    },
    es: {
        images: "Imágenes",
    },
};

const FormDataIsland = () => {
    const [_Tr] = useTranslation("routes");
    const [t] = useTranslation("forms");
    const {t: _TC} = CustomTranslation(translations);
    document.title = t("labels.island");
    const {formatDate, timezone} = MomentUtils();

    const {id} = useParams();

    const [item, setItem] = useState({...IslandModel});
    const [measures, setMeasures] = useState([]);
    const [items, setItems] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [showPrevImage, setShowPrevImage] = useState(false);
    const [showGallery, setShowGallery] = useState(false);
    const [dateRange, setDateRange] = useState(null);
    const chartRefs = useRef({});
    const [isLoading, setIsLoading] = useState(false);

    const bread = [
        {name: _Tr("labels.data-view"), url: "/data-view/", current: false},
        {
            name: _Tr("labels.containers"),
            url: "/data-view/islands/",
            current: false,
        },
        {name: t("labels.island"), current: true},
    ];

    useEffect(() => {
        const endDate = new Date();
        const startDate = new Date();
        if (dateRange) {
            const params = {
                island: id,
                start: DateUtils.dateToStringInput(dateRange.startDate),
                end: DateUtils.dateToStringInput(dateRange.endDate || dateRange.startDate),
            };
            axiApi
                .post(`/api/distribution/island/data/`, params)
                .then((resp) => {
                    setItem({...resp.data.item, id: id});
                    setItems([...resp.data.items]);
                    let measurs = {...resp.data.measures};
                    let alert;
                    for (alert of resp.data.alerts) {
                        if (!(alert.uuid in measurs)) {
                            measurs[alert.uuid] = {};
                        }
                        if (!("alerts" in measurs[alert.uuid])) {
                            measurs[alert.uuid]["alerts"] = new AlertsTypesCharts();
                        }
                        if (!(alert.type in measurs[alert.uuid]["alerts"])) {
                            measurs[alert.uuid]["alerts"][alert.type] = [];
                        }
                        measurs[alert.uuid]["alerts"][alert.type].push({
                            x: alert.date * 1000,
                            y: 100,
                        });
                    }
                    setMeasures(measurs);
                    setIsDataLoaded(true);
                    getAzureLastImages();
                })
                .catch(() => {
                    setMeasures([]);
                    setIsDataLoaded(true);
                });
        } else {
            startDate.setDate(endDate.getDate() - 7);
            setDateRange({startDate, endDate});
            setMeasures([]);
            setIsDataLoaded(true);
            return;
        }
    }, [dateRange, id]);

    const getAzureLastImages = () => {
        setIsLoading(true);
        axiApi
            .get(`/api/distribution/last/image/`, {params: {id_isla: id}})
            .then((resp) => {
                // Set Directo Caca
                const items = resp.data.items;
                if (items?.length > 0) {
                    setItem((prev) => ({
                        ...prev,
                        image: {
                            url: items[0].src,
                            dated: items[0].dated,
                            camera: items[0].camera,
                        },
                    }));
                }
            })
            .catch((error) => {
                console.error(error);
                setItem((prev) => ({...prev, image: {url: null, dated: null, camera: null}}));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDateRangeChange = (newDateRange) => {
        setDateRange(newDateRange);
    };

    const handleResetZoom = () => {
        if (isDataLoaded) {
            const uuids = Object.keys(measures);
            uuids.forEach((uuid) => {
                if (chartRefs && chartRefs.current && chartRefs.current[uuid]) {
                    const refs = chartRefs.current[uuid];
                    if (refs.filling) {
                        refs.filling.resetZoom();
                    }
                    if (refs.battery) {
                        refs.battery.resetZoom();
                    }
                    if (refs.temperature) {
                        refs.temperature.resetZoom();
                    }
                }
            });
        }
    };
    const noImage = () => {
        return (
            <div className="col-12">
                <img src={`${urlStatic}/images/no-image.jpg`} alt="No Image" height={300} />
            </div>
        );
    };

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 preview-canvas offcanvas-header mt-1">
                        <div className="preview-icon">
                            <FontAwesomeIcon icon="boxes-stacked" />
                        </div>
                        <div className="preview-title ps-4">
                            <h5>{t("labels.island")}</h5>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <label className="d-inline-block small me-2 text-secondary">{t("common.name")}:</label>
                        <span className="d-inline-block text-black h5">{item.name}</span>
                    </div>
                    <div className="col-12 mb-3">
                        <label className="d-inline-block small me-2 text-secondary">{t("common.description")}</label>
                        <span className="d-inline-block text-black h5">{item.description}</span>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-xl-2 col-12"></div>
                    <div className="col-lg-4 col-12 mb-3 mb-lg-0">
                        <ConditionalRender condition={item.coords}>
                            <MapAssetContainer openMap={true} coords={item.coords} />
                            <div className="text-center bg-secondary text-light">
                                {item.coords[0]}, {item.coords[1]}
                            </div>
                        </ConditionalRender>
                    </div>
                    <div className="col-lg-6 col-12 position-relative">
                        <LoaderSpinner isLoading={isLoading}>
                            <ConditionalRender condition={item?.image?.url || false} fallback={noImage()}>
                                <div className="d-inline-block">
                                    <img
                                        src={item.image.url}
                                        alt="Asset Image"
                                        className="img-responsive"
                                        height={300}
                                        style={{cursor: "pointer"}}
                                        onClick={() => setShowPrevImage(true)}
                                    />
                                    <div className="text-center bg-secondary text-light">
                                        {formatDate(item.image.dated, "DD-MM-YYYY HH:mm") + " - " + item.image.camera}
                                    </div>
                                </div>
                                <div className="" style={{position: "absolute", bottom: "21px", left: "11px"}}>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        title="Ver mas imagenes"
                                        onClick={() => setShowGallery(true)}>
                                        <FontAwesomeIcon icon="plus" /> {_TC("images")}
                                    </button>
                                </div>

                                <ImageModal
                                    show={showPrevImage}
                                    onHide={() => setShowPrevImage(false)}
                                    imageSrc={item.image.url}
                                    imageAlt={formatDate(item.image.dated, "DD-MM-YYYY HH:mm")}
                                    camera={item.image.camera}
                                />

                                <ConditionalRender condition={showGallery}>
                                    <ModalIslandImages show={showGallery} setShow={setShowGallery} island={item} />
                                </ConditionalRender>
                            </ConditionalRender>
                        </LoaderSpinner>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <h4 className="text-center">{t("common.containers")}</h4>
                        <div className="row">
                            <div className="col-12 text-center mb-5">
                                {items.map((act, idx) => (
                                    <div className="d-inline-block asset-icon-measures p-2" key={idx} style={{width: "250px"}}>
                                        <ContainerIconValues item={act} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row ">
                            <div className="">
                                <div className="col-12 d-flex justify-content-center mb-3 ">
                                    <button className="btn btn-sm btn-outline-primary me-3" onClick={handleResetZoom}>
                                        <FontAwesomeIcon icon="rotate-right" /> Zoom
                                    </button>
                                    <div
                                        style={{
                                            display: "inline-block",
                                            minWidth: "200px",
                                            maxWidth: "200px",
                                        }}>
                                        <DropdownDateRange
                                            size="sm"
                                            dateRange={dateRange}
                                            setDateRange={handleDateRangeChange}
                                            maxDays={30}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="mt-3" />
                </div>
                <AssetsList items={items} measures={measures} chartRefs={chartRefs} />
            </div>
        </>
    );
};
export default FormDataIsland;
